<template>
  <body>
    <slot />
  </body>
</template>

<script>
import "../styles.scss";
export default {};
</script>
